import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { MinimumSpanningTreeGraph } from './minimum-spanning-tree-graph';
import { GraphService } from '../../General/graph/graph.service';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { SymmetricWeightedEdge } from '../../General/graph/symmetric/symmetric-weighted-edge';
import { GraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/graph-exercise.component';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';
import { GraphUW } from '../../shared/interactive-graph/simple_graphs/graphUW';
import { InteractionType } from 'graph-interactive/dist/lib/interactive/InteractionType';
import { Weightable, GraphAlgorithm, Interactable } from 'graph-interactive';
import { AbstractNode } from 'graph-interactive/dist/lib/abstract/aNode';

@Component({
  selector: 'app-minimum-spanning-tree',
  templateUrl: './minimum-spanning-tree.component.html',
  styleUrls: ['./minimum-spanning-tree.component.css']
})
export class MinimumSpanningTreeComponent extends GraphExerciseComponent {


  private readonly resetSelectionID: string = 'resetSelectionButton';
  private readonly canvasID: string = 'graph-canvas';

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService,
    protected messageService: MessageService, graphService: GraphService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
    this.type = 'minimumSpanningTree';
  }

  initGraph(): InteractiveGraph {
    let canvas = <HTMLCanvasElement>document.getElementById(this.canvasID); //Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized
    let nGraph = new MSTGraphUW(canvas);
    return nGraph;
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.graph.setInteractionType(InteractionType.HIGHLIGHT_EDGE);
    let resetSelectionButton = <HTMLButtonElement>document.getElementById(this.resetSelectionID);
    resetSelectionButton.addEventListener('click', this.resetSelection, false);
  }



  checkSolution() {
    if (this.graph == null) {
      console.log("Graph null");
      return;
    }
    if (this.graph != null && this.checkReach()
        &&GraphAlgorithm.testConnectivityViaEdges(this.graph.getSelectedEdges()
         ,this.graph.getGraph())) {

      let ev = this.evaluate();
      if (ev[0] == ev[1]) {
        this.messageService.addAlertWithTimeout(this.get('correct'), 'success', 10000);
        this.messageService.addAlertWithTimeout(this.get('FoundMST'), 'success', 20000);
        this.solved = true;
        this.state.solved = true;
        this.saveState();
      }
      else {
        this.messageService.addAlertWithTimeout(this.get('NotFoundMST'), 'danger', 10000);
      }
    } else {
      this.messageService.addAlertWithTimeout((this.get('NodesMissingMST')), 'danger', 10000);
    }
  }

  checkReach():boolean{
      let reach = true;

      let nodes = this.graph.getGraph().getNodes();
      let edges = this.graph.getSelectedEdges();

      nodes.forEach(node => {
          let nodeReached = false;
          edges.forEach(edge => {
            if((edge.getEndNode() == node || edge.getStartNode() == node)){
                nodeReached = true;
            }
          })
          if(!nodeReached){
            reach = false;
          }
      })
      return reach;
  }

  

  ngOnInit() {
    super.ngOnInit();
  }

  resetSelection = () => {
    if (this.graph != null) {
      this.graph.resetSelected();
      this.graph.forceUpdate();
    }
  }

  setTypeSpecificsFromState() {
  }

  spannTreeWeight(): number {
    if (this.graph == null) {
      return 0;
    }
    let edges = this.graph.getSelectedEdges();
    let sum = 0;
    if (edges != null) {
      edges.forEach(edge => {
        if (Weightable.isWeightable(edge)) {
          sum = sum + edge.getWeight();
        }
      });
    }
    return sum;
  }

  computeState() {
  }

  resetState() {
    this.graph.resetSelected();
    this.graph.forceUpdate();
    super.resetState();
  }

  setTypeSpecificsFromConfiguration() {
  }

  evaluate(): [number, number] {
    let edges = GraphAlgorithm.primMST(this.graph.getGraph());

    let expected = 0;
    edges.forEach(edge => {
      if (Weightable.isWeightable(edge)) {
        expected = expected + edge.getWeight();
      }
    })

    return [expected >= this.spannTreeWeight() ? 1 : 0, 1];
  }
}


//Specific graph for making edges non interactable
class MSTGraphUW extends GraphUW {
  disableHover(interactabe: Interactable): boolean {
    if (interactabe instanceof AbstractNode) {
      return true;
    }
    return super.disableHover(interactabe);
  }
}
